import React, { useCallback, useEffect, useState } from 'react';
import LoadingSpinner from '../common/LoadingSpinner';
import { getPlatformLeads } from '../../services/api';
import { formatDateTime } from '../../utils/formatters';

// Лиды, отправленные лендингом ДО финального сабмита формы (email потерял
// фокус, но человек не закончил регистрацию) — иначе такие визиты были
// видны только как анонимная ++ в воронке, без возможности связаться.
const LeadsCard = () => {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getPlatformLeads();
      setLeads(data.leads || []);
      setError('');
    } catch (e) {
      setError('Не удалось загрузить лиды');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <section className="ui-card">
      <div className="ui-card-head">
        <h2>Незавершённые регистрации</h2>
        <p>Email введён на лендинге, но форма не досдана до конца — можно написать самим.</p>
      </div>

      {loading && <LoadingSpinner />}
      {!loading && error && <div className="ui-inline-error">{error}</div>}
      {!loading && !error && leads.length === 0 && (
        <div className="ui-empty">Пока никто не начал и не бросил регистрацию</div>
      )}
      {!loading && !error && leads.length > 0 && (
        <div className="platform-org-table">
          {leads.map((lead) => (
            <div className="platform-org-row" key={lead.id}>
              <div className="platform-org-main">
                <div className="platform-org-name">{lead.email}</div>
                <div className="ui-dim">
                  {lead.org_name || 'без названия'}{lead.phone ? ` · ${lead.phone}` : ''}
                </div>
              </div>
              <span className="ui-dim">{formatDateTime(lead.created_at)}</span>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default LeadsCard;
